import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ActiveMarketApiClient } from 'api';
import { ItemActiveMarketData } from 'models/Item/types';

export const useActiveMarket = (
	options?: Omit<UseQueryOptions<ItemActiveMarketData>, 'queryKey' | 'queryFn'>
) => {
	return useQuery({
		queryKey: ['activeMarket', 'all'],
		queryFn: () => ActiveMarketApiClient.getAllActiveMarket(),
		...options,
	});
};
